export default "__VITE_PUBLIC_ASSET__891f2dcc__"